import { ScrollView, Text, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useTranslation } from 'react-i18next'

import type { BuyQueryResult, SellQueryResult } from '@/types/common'
import { ChildOrderDetailSection } from '@/components/orders/child/DetailSection'
import { ChildOrderPaymentSection } from '@/components/orders/child/PaymentSection'
import { ImageViewerSection } from '@/components/orders/ImageViewerSection'
import { RevisingOrderSection } from '@/components/orders/RevisingOrderSection'

export function ChildOrderCanceledScreen({
  data,
  type,
  parentInternalKey
}: {
  data:
    | BuyQueryResult['userGetBuyOrderByInternalKey']
    | SellQueryResult['userGetSellOrderByInternalKey']['pairBuyOrder'][number]
  type: 'buy' | 'sell'
  parentInternalKey?: string
}) {
  const { t } = useTranslation()
  const { bottom } = useSafeAreaInsets()
  return (
    <>
      <View className={'flex-1 bg-background-secondary'}>
        <ScrollView className={'flex-1'} contentContainerStyle={{ paddingBottom: bottom }}>
          <View className={'border-b border-border-10 bg-background-primary px-4 pb-[11px] pt-2'}>
            <Text className={'text-2xl font-semibold text-text-primary'}>{t('orders:transactionCancelled')}</Text>
          </View>
          <ChildOrderDetailSection data={data} type={type} parentInternalKey={parentInternalKey} />
          {data.dealAmount.value !== data.originDealAmount.value && (
            <RevisingOrderSection
              dealAmount={data.dealAmount}
              originDealAmount={data.originDealAmount}
              basePrice={data.basePrice}
              changeAmountProof={data.changeAmountProofBucketPath}
            />
          )}
          {((type === 'buy' && data.sellOrderPaymentMethod !== null) ||
            (type === 'sell' && data.paymentMethod !== null)) && <ChildOrderPaymentSection data={data} type={type} />}
          {data.paymentProofUrl && <ImageViewerSection images={data.paymentProofUrl} />}
        </ScrollView>
      </View>
    </>
  )
}
